import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, LOADING_MESSAGE, LoadingIndicator, Placeholder, ExpansionBody} from '@fupa/fupa-uikit';
import CupTable from 'app/components/cup/CupTable';
import GroupHeader from 'app/components/cup/group/GroupHeader';
import {MatchRow} from 'app/components/match/matchRow/MatchRow';
import {checkDesktopLayout} from 'app/styles/media';
import {CompetitionCaption} from 'app/styles/heading';
import {formatDateWithWeekday} from 'app/helpers/dateHelpers';
import {windowIsDefined} from 'app/helpers/windowIsDefined';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${COLORS.white};
  vertical-align: middle;
  flex: 0 100%;
  flex-wrap: wrap;
`;

const MatchContainer = styled.div`
  width: 100%;
  padding: ${SIZES['16']} 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const StyledPlaceholder = styled(Placeholder)`
  &&& {
    background-color: transparent;
  }
`;

const heightConstants = {
  loadingIndicator: 90,
  matchRow: 138,
  matchContainerPadding: 32,
  placeholder: 48,
  standingsRow: 36,
  standingsHeader: 36,
};

const CupRow = ({group, detail, loadMatches, setShow}) => {
  const isFetching = detail?.isFetching ?? false;
  const show = detail?.show ?? false;
  const error = detail?.error ?? null;
  const {matches, standings} = detail?.items ?? {matches: [], standings: []};

  const handleGroup = () => {
    if (!show && !matches.length && !standings.length && !error) {
      loadMatches(group.slug);
    } else {
      setShow(group.slug, !show);
    }
  };

  const groupMatchRow = matches.map(match => (
    <MatchRow
      key={match.slug}
      match={match}
      colored={false}
      caption={
        match.kickoff ? (
          <CompetitionCaption variant='caption1'>{formatDateWithWeekday(match.kickoff, true)}</CompetitionCaption>
        ) : null
      }
      dynamicDateformat={true}
    />
  ));

  const displayTable = group?.type === 'cupgroup' && !isFetching ? <CupTable standings={standings} /> : null;

  let showMatchContainer, matchesHeight;
  if (isFetching) {
    showMatchContainer = <LoadingIndicator message={LOADING_MESSAGE.loadingMatches} bgColor={false} />;
    matchesHeight = heightConstants.loadingIndicator;
  } else if (matches.length > 0) {
    showMatchContainer = <MatchContainer>{groupMatchRow}</MatchContainer>;
    const isDesktop = windowIsDefined ? checkDesktopLayout() : false;
    const rowCount = isDesktop && matches.length > 1 ? Math.round(matches.length / 2) : matches.length;
    matchesHeight = rowCount * heightConstants.matchRow + heightConstants.matchContainerPadding;
  } else if (error) {
    showMatchContainer = <StyledPlaceholder>Beim Laden der Daten ist ein Fehler aufgetreten.</StyledPlaceholder>;
    matchesHeight = heightConstants.placeholder;
  } else {
    showMatchContainer = <StyledPlaceholder>Noch keine Spiele eingetragen.</StyledPlaceholder>;
    matchesHeight = heightConstants.placeholder;
  }

  const tableHeight = displayTable
    ? standings.length * heightConstants.standingsRow + heightConstants.standingsHeader
    : 0;
  const bodyHeight = show ? tableHeight + matchesHeight : 0;

  const showStandings = (
    <ExpansionBody bgColor={COLORS.white} height={bodyHeight}>
      {displayTable}
      {showMatchContainer}
    </ExpansionBody>
  );

  return (
    <Container>
      <GroupHeader
        onClick={handleGroup}
        type={group?.type}
        teams={group?.teamSeasons}
        title={group?.title}
        show={show}
      />
      {showStandings}
    </Container>
  );
};

export default CupRow;
